var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKcalIcon = function SvgKcalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 481414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 11.8444L2.81111 17H14.1889L16.5 11.8444C15.6111 10.4222 11.9909 8.46666 8.5 8.46666C5.00909 8.46666 1.38889 10.4222 0.5 11.8444Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 10.4222V11.8444",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.79785 10.7778L6.15341 12.2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.16675 11.8445L3.87786 12.9111",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.9889 10.7778L10.6333 12.2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.62 11.8445L12.9089 12.9111",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.50005 17L5.30005 13.9778",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.81104 1V3.13333M2.81104 3.13333V5.26667M2.81104 3.13333L4.94437 1M2.81104 3.13333L4.94437 5.26667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.78901 2.42221H7.43345C6.64798 2.42221 6.01123 3.05896 6.01123 3.84443C6.01123 4.6299 6.64798 5.26666 7.43345 5.26666H7.78901",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.21118 5.26666L9.47785 4.55554M9.47785 4.55554L10.2778 2.42221L11.0778 4.55554M9.47785 4.55554H11.0778M11.3445 5.26666L11.0778 4.55554",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.7666 2.42221V5.26666H14.1888",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgKcalIcon;